const initialFilters = {
  location_address: '',
  location_inspection_comment: '',
  inspectors: {
    options: [],
    value: null,
  },
  location_types: {
    options: [],
    value: null,
  },
  inspection_types: {
    options: [],
    value: null,
  },
}

export const inspection_polygons = {
  namespaced: true,
  state() { return {
    filters: initialFilters,
  }},
  getters: {
    filters: state => state.filters,
  },
  actions: {
    changeFilter({ commit }, payload) {
      commit('changeFilter', payload);
    },
    clearFilter({ commit }) {
      commit('clearFilter');
    },
  },
  mutations: {
    changeFilter(state, payload) {
      state.filters = payload;
    },
    clearFilter(state) {
      state.filters = initialFilters;
    },
  }
};